import React from "react";

export const ARCHIVE_VIEWS = [["active", "Active"], ["archived", "Archived"], ["all", "All"]];
export const normView = (v) => (v === "inactive" ? "archived" : ARCHIVE_VIEWS.some(([k]) => k === v) ? v : "active");
export const isArchived = (r) => r.status === "archived";
export const inView = (r, view) => view === "all" || (view === "archived") === isArchived(r);
export const countViews = (rows) => {
  const archived = rows.filter(isArchived).length;
  return { all: rows.length, archived, active: rows.length - archived };
};

/** Active / Archived / All picker shared by every card that lists residents or records. */
export function ArchiveViewChips({ prefix, view, setView, counts, size = "md" }) {
  const pad = size === "sm" ? "px-2.5 py-1 text-[9px]" : "px-3 py-1 text-[10px]";
  return (
    <div data-testid={`${prefix}-views`} className="inline-flex flex-wrap gap-1.5">
      {ARCHIVE_VIEWS.map(([id, label]) => (
        <button key={id} type="button" onClick={() => setView(id)} data-testid={`${prefix}-filter-${id}`} aria-pressed={view === id}
          className={`${pad} rounded-full border font-mono tracking-[0.18em] uppercase transition-colors ${
            view === id ? "border-nex-gold bg-nex-gold/15 text-nex-gold" : "border-white/10 text-nex-muted hover:text-nex-silver hover:border-white/30"}`}>
          {label}{counts ? ` · ${counts[id] ?? 0}` : ""}
        </button>
      ))}
    </div>
  );
}
